module.exports = __webpack_public_path__ + "img/reclaim-failure.e8453cc4.png";